import { Button, styled } from "@mui/material";
import { FC } from "react";
import { useTranslation } from "react-i18next";
import { text, primary } from "@/theme/colors";
import { typography } from "@/theme/typography";
import { rounded, spacing } from "@/theme/variables";

const StyledButton = styled(Button)({
  minHeight: 44,
  borderRadius: rounded.sm,
  paddingLeft: spacing.sm,
  paddingRight: spacing.sm,
  backgroundColor: primary[500],
  color: text.white,
  textTransform: "none",
  ...typography.body14Bold,
  "&:hover": {
    backgroundColor: primary[400],
  },
});

type TakeExamButtonProps = {
  onClick: () => void;
};

export const TakeExamButton: FC<TakeExamButtonProps> = ({ onClick }) => {
  const { t } = useTranslation();
  return (
    <StyledButton onClick={onClick} variant="contained">
      {t("mockExam.startButton")}
    </StyledButton>
  );
};
